<template>
  <div class="card">
    <img :src="require(`@/assets/${imgPath}`)" :alt="imgName" class="card-img" />
    <div class="card-text">
      <h4 class="card-title" v-html="title"></h4>
      <p class="card-description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardContent",
  props: {
    imgPath: String,
    imgName: String,
    title: String,
    description: String,
  }
}
</script>

<style lang="scss" scoped>
.card {
  .card-img {
    width: 100%;
  }
  .card-title {
    font-weight: normal;
    font-size: 24px;
    margin: 20px auto;
    color: var(--main);
    justify-content: center;
    text-align: center;
    min-height: 72px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    @media screen and (max-width: 767px) {
      font-weight: 700;
      font-size: 20px;
      margin: 15px auto;
      min-height: 48px;
    }
  }
}
</style>